import { render, staticRenderFns } from "./P_supply-chain.vue?vue&type=template&id=a04dcbfc&scoped=true&"
import script from "./P_supply-chain.vue?vue&type=script&lang=js&"
export * from "./P_supply-chain.vue?vue&type=script&lang=js&"
import style0 from "./P_supply-chain.vue?vue&type=style&index=0&id=a04dcbfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04dcbfc",
  null
  
)

export default component.exports